import React from 'react'
import DemandDetailsComponent from '../../components/DemandDetailsComponent'

function DemandDetails() {
  return <DemandDetailsComponent />
}

export default DemandDetails
